import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="parent-sharing-lock", on the class form. A specialization of one of the author's
// private base classes cannot be shared, so while that parent is picked the sharing select reads "Privado" and is
// disabled; the server refuses it anyway.
export default class extends Controller<HTMLFormElement> {
	static targets = ["select", "tip", "hints", "name"];
	static values = { privateParents: Object };
	declare readonly selectTarget: HTMLSelectElement;
	declare readonly tipTarget: HTMLElement;
	declare readonly hintsTarget: HTMLElement;
	declare readonly nameTarget: HTMLElement;
	declare readonly hasSelectTarget: boolean;
	declare readonly hasTipTarget: boolean;
	declare readonly hasHintsTarget: boolean;
	declare readonly privateParentsValue: Record<string, string>;

	check() {
		if (!this.hasSelectTarget || !this.hasTipTarget || !this.hasHintsTarget) return;
		const parent = this.element.querySelector<HTMLSelectElement>("select[name='character_class[parent_character_class_id]']");
		const name = parent && !parent.disabled ? this.privateParentsValue[parent.value] : undefined;
		const locked = name !== undefined;
		if (locked) {
			this.selectTarget.value = "not_shared";
			this.nameTarget.textContent = name;
		}
		// A pinned reason (the class names private spells) keeps the select locked whatever the parent.
		const pinned = this.selectTarget.dataset.pinned !== undefined;
		this.selectTarget.disabled = locked || pinned;
		this.tipTarget.hidden = !locked;
		this.hintsTarget.hidden = locked || pinned;
	}
}
